import { Feature } from '../../types/Feature';
import { getApi } from '../getApi/index';

export const getFeatures = async (
  profileId?: string,
  segmentIds?: string,
): Promise<Feature[]> => {
  const params: Record<string, string> = {};

  if (profileId) params.profileId = profileId;
  if (segmentIds) params.segmentIds = segmentIds;

  const { data } = await getApi().get<Feature[]>(`/features`, {
    params,
  });
  return data;
};
